import(/* webpackMode: "eager", webpackExports: ["AppContainer"] */ "/app/src/components/containers/app-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/context/app-page-context-provider.tsx");
